import icon from 'vue-svgicon';

icon.register({
    'regular/wench-1': {
        width: 16,
        height: 16,
        viewBox: '0 0 24 24',
        data: `<path pid="0" d="M9.4 16.742L16.741 9.4a4.55 4.55 0 0 0 6.066-6.066l-1.425 1.429a1.516 1.516 0 0 1-2.144-2.144l1.424-1.425A4.55 4.55 0 0 0 14.6 7.26L7.259 14.6a4.55 4.55 0 0 0-6.066 6.066l1.425-1.424a1.516 1.516 0 0 1 2.144 2.144l-1.424 1.422A4.55 4.55 0 0 0 9.4 16.742z" _fill="none" _stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/>`,
    },
});
